import { useEffect } from 'react';
import { useSession, selectReducedMotion } from '@/stores/session';
import { configureFx } from './config';
import { sound } from './sound';
import { music } from './music';
import { installAudioListeners } from './audioCore';

/** Mirrors session prefs into the FX kit and <html data-reduced-motion>; follows the OS setting live. */
export function useFxSync(): void {
  const reduced = useSession(selectReducedMotion);
  const soundOn = useSession((s) => s.sound);
  const musicOn = useSession((s) => s.music);
  const setOs = useSession((s) => s.setOsReducedMotion);

  useEffect(() => {
    configureFx({ reduced, sound: soundOn, music: musicOn });
    document.documentElement.dataset.reducedMotion = String(reduced);
  }, [reduced, soundOn, musicOn]);

  // sound on → load common (+ the current screen's group); off → stop loops and the Liftoff hum
  useEffect(() => {
    installAudioListeners();
    sound.sync();
  }, [soundOn]);

  // music on → the route's track (after the first gesture); off → fade out
  useEffect(() => {
    music.sync();
  }, [musicOn]);

  useEffect(() => {
    let mq: MediaQueryList;
    try {
      mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    } catch {
      return;
    }
    const on = () => setOs(mq.matches);
    on();
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, [setOs]);
}
